/* Custom JS: mega-menu hover image preview */

var defaultImages = {
  '/collections/men-socks': 'https://cdn.shopify.com/s/files/1/0835/1005/collections/H_CHARLES_000006740019_4c1f8550-d51f-4282-8fbd-25ba6ab20d39_800x.jpg?v=1781874196',
  '/collections/women-socks': 'https://cdn.shopify.com/s/files/1/0835/1005/collections/EMMA_000008120022_800x.jpg?v=1781874380',
  '/collections/small-leather-goods': 'https://cdn.shopify.com/s/files/1/0835/1005/collections/Escuyer-leather-cardholder-wallet-Burgundy-Red-1_800x.jpg?v=1782136201'
};

var disabledTopLinks = [
  '/collections/men-socks',
  '/collections/women-socks',
  '/collections/small-leather-goods'
];

function initMegaMenu() {
  document.querySelectorAll('[data-top-link]').forEach(function(link) {
    var href = link.getAttribute('href');

    /* Disable click */
    if (disabledTopLinks.indexOf(href) !== -1) {
      link.addEventListener('click', function(e) { e.preventDefault(); });
      link.style.cursor = 'default';
    }

    /* Show collection image only while hovering the top-level link */
    if (defaultImages[href]) {
      link.addEventListener('mouseenter', function() {
        var trigger = link.closest('[aria-controls]');
        if (!trigger) return;
        var dropdown = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!dropdown) return;
        var preview = dropdown.querySelector('.mega-menu-preview__image');
        if (!preview) return;
        preview.setAttribute('src', defaultImages[href]);
        preview.classList.add('is-visible');
      });

      /* Hide when leaving the top-level link toward outside (not into dropdown) */
      link.addEventListener('mouseleave', function(e) {
        var trigger = link.closest('[aria-controls]');
        if (!trigger) return;
        var dropdown = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!dropdown) return;
        /* Only hide if not entering the dropdown */
        if (e.relatedTarget && e.relatedTarget.closest('.header__dropdown') === dropdown) return;
        var preview = dropdown.querySelector('.mega-menu-preview__image');
        if (preview) {
          preview.classList.remove('is-visible');
        }
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', initMegaMenu);
if (document.readyState !== 'loading') initMegaMenu();

/* On hover over a sub-collection link, show its image instantly */
document.addEventListener('mouseover', function (e) {
  var link = e.target.closest('[data-img]');
  if (!link) return;

  var dropdown = link.closest('.header__dropdown');
  if (!dropdown) return;

  var preview = dropdown.querySelector('.mega-menu-preview__image');
  if (!preview) return;

  var imgSrc = link.getAttribute('data-img');
  if (imgSrc) {
    /* Swap src directly — no fade out in between */
    preview.setAttribute('src', imgSrc);
    preview.classList.add('is-visible');
  }
});

/* Hide image only when leaving a sub-collection link toward a non-[data-img] area */
document.addEventListener('mouseout', function (e) {
  var link = e.target.closest('[data-img]');
  if (!link) return;

  var dropdown = link.closest('.header__dropdown');
  if (!dropdown) return;

  var relatedTarget = e.relatedTarget;

  /* Moving to another [data-img] link — mouseover will handle it, don't hide */
  if (relatedTarget && relatedTarget.closest('[data-img]')) return;

  /* Still inside the dropdown but no [data-img] — hide the preview */
  var preview = dropdown.querySelector('.mega-menu-preview__image');
  if (preview) {
    preview.classList.remove('is-visible');
    /* Keep src so next hover is instant, no blank flash */
  }
});

/* Hide when leaving the dropdown entirely */
document.addEventListener('mouseleave', function (e) {
  var dropdown = e.target.closest('.header__dropdown');
  if (!dropdown) return;
  var preview = dropdown.querySelector('.mega-menu-preview__image');
  if (preview) {
    preview.classList.remove('is-visible');
  }
}, true);
